module.exports = __webpack_public_path__ + "static/media/inventory-mockup.2d0ed903.jpg";